import './HomeLandPage.css'
import {useNavigate} from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next';
import { Facebook, Instagram, LinkedIn, Twitter } from '../../../Assets/SVGS';
function HomeLandPage(){
  const nav = useNavigate()
  const { t } = useTranslation();
  return (
    <div className='homeLandPage-container container'>
      <div className="decorations">
        <span className="deco-ring ring-1"></span>
        <span className="deco-ring ring-2"></span>
        <span className="deco-cross cross-1"></span>
        <span className="deco-cross cross-2"></span>
        <span className="deco-cross cross-3"></span>
      </div>

      <div className="homeLandPage-social">
        <a href='https://www.facebook.com/share/1WT384W32D/' target='_blank' rel="noreferrer"><Facebook width="18px"/></a>
        <a href='https://www.instagram.com/dr.markatefdentalclinic/' target='_blank' rel="noreferrer"><Instagram width="18px"/></a>
        <a href='https://www.instagram.com/dr.markatefdentalclinic/' target='_blank' rel="noreferrer"><LinkedIn width="18px"/></a>
        <a href='https://www.instagram.com/dr.markatefdentalclinic/' target='_blank' rel="noreferrer"><Twitter width="18px"/></a>
      </div>

      <div className='homeLandPage-content content'>
        <h2>
          <Trans i18nKey="heroTitle">we provide <span>medical</span> services that you can <span>trust!</span></Trans>
        </h2>
        <p>
          {t('heroDesc')}
        </p>
        <div className="btns">
          <button onClick = {()=>nav('/booking')}>{t('getAppointment')}</button>
        </div>
      </div>
    </div>
  );
}
export default HomeLandPage